<template>
    <div class="backSpecial">
        <router-link to="/" style="color:#2B26EC">返回首页</router-link>
    </div>
</template>

<script>
    export default {
        name:"backSpecial",
        data() {
            return {

            }
        }
    }
</script>

<style lang="less" scoped>
    .backSpecial{
        margin-bottom: 20px;
    }
    
</style>